import { Box } from "@remo-co/ui-core/src/components/Box";
import { ScrollableView } from "@remo-co/ui-core/src/components/ScrollableView";
import { maxContentWidth } from "@remo-co/ui-core/src/constants";
import { useI18n } from "i18n";
import { getRemoHosts } from "config";
import { AppBarContainer } from "modules/app/menu/components/AppBarContainer";
import { MyEventsContainer } from "modules/event/components";
import { usePageSettingReducerActions } from "modules/pageSetting/context/pageSettingReducer";
import { selectBrandName } from "modules/settings/redux/selectors";
import { PAGES, usePageTracking } from "modules/tracking";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Footer } from "modules/eventLanding/components/Footer";
import { selectIsAnonymousUser } from "modules/auth/redux/selectors";
import logo from "../../assets/logo.svg";
import { styles } from "./styles";

const MyEventsPage = () => {
  const { t } = useI18n(["common", "event"]);

  const { setPageTitle } = usePageSettingReducerActions();
  const isRemoDomain = getRemoHosts().includes(window.location.host);
  const brandName = useSelector(selectBrandName);
  const isUserAnonymous = useSelector(selectIsAnonymousUser);

  useEffect(() => {
    setPageTitle("");
  }, [setPageTitle]);

  usePageTracking(PAGES.MY_EVENTS);

  return (
    <>
      <AppBarContainer
        title={
          isRemoDomain
            ? t("event:welcome.to.remo")
            : t("event:welcome.to.custom.domain", {
                companyName: brandName,
              })
        }
        logoImage={<img src={logo} alt="logo" style={styles.logo} />}
      />
      <ScrollableView withAppBar>
        <Box
          boxSizing="border-box"
          maxWidth={maxContentWidth}
          mx="auto"
          px={3}
          width="100%"
        >
          <MyEventsContainer />
        </Box>
        <Footer hideCreateEventButton={isUserAnonymous} />
      </ScrollableView>
    </>
  );
};

export default MyEventsPage;
